/**
 * relativeDate — tiny helpers for human-readable dates in cards.
 * Spanish output, no external deps.
 */

const DAY = 1000 * 60 * 60 * 24;

/** Whole-day difference between iso and now (rounded down, signed). */
export function daysFromNow(iso) {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return null;
  // Compare day-precision in local TZ to avoid "vence en 0" ambiguity.
  const a = new Date(t);
  const b = new Date();
  a.setHours(0, 0, 0, 0);
  b.setHours(0, 0, 0, 0);
  return Math.round((a.getTime() - b.getTime()) / DAY);
}

/** Days elapsed since iso (positive). null if invalid/missing. */
export function daysSince(iso) {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return null;
  return Math.max(0, Math.floor((Date.now() - t) / DAY));
}

/** Short relative due date: "vence hoy" / "vence mañana" / "vence en 3d" / "vencido hace 2d". */
export function relativeDueDate(iso) {
  const d = daysFromNow(iso);
  if (d === null) return null;
  if (d === 0) return { text: "vence hoy", tone: "amber" };
  if (d === 1) return { text: "vence mañana", tone: "amber" };
  if (d > 1) return { text: `vence en ${d}d`, tone: d <= 3 ? "amber" : "stone" };
  if (d === -1) return { text: "vencido ayer", tone: "red" };
  return { text: `vencido hace ${-d}d`, tone: "red" };
}

/** Short "última actividad": hoy / hace Xd / hace Xs / hace Xm. */
export function relativeActivity(iso) {
  const d = daysSince(iso);
  if (d === null) return null;
  if (d === 0) return "hoy";
  if (d === 1) return "ayer";
  if (d < 7) return `hace ${d}d`;
  if (d < 30) return `hace ${Math.floor(d / 7)}sem`;
  return `hace ${Math.floor(d / 30)}m`;
}
